import _styled from "@emotion/styled-base";
import React from 'react';
import PropTypes from 'prop-types';
import Text from '../Text/Text';
import { elo as theme } from '../../themes';
import { variantsPropType } from '../../util';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Action = function Action(_ref) {
  var action = _ref.action,
    actionLink = _ref.actionLink,
    actionTarget = _ref.actionTarget,
    onClick = _ref.onClick,
    onKeyUp = _ref.onKeyUp,
    variant = _ref.variant;
  return ___EmotionJSX(ActionContent, {
    onClick: onClick,
    onKeyUp: onKeyUp,
    role: "button",
    tabIndex: -1
  }, ___EmotionJSX(Text, {
    element: "a",
    href: (actionLink == null ? void 0 : actionLink.length) > 0 ? actionLink : null,
    target: (actionTarget == null ? void 0 : actionTarget.length) > 0 ? actionTarget : null,
    semibold: true,
    size: "t3",
    variant: variant
  }, action));
};
var ActionContent = _styled("span", {
  target: "e1illcw80"
})("cursor:pointer;margin-left:", theme.spacings.xxxSmall, ";&:focus{outline:none;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RvYXN0L0FjdGlvbi5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0NpQyIsImZpbGUiOiIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Ub2FzdC9BY3Rpb24uanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmltcG9ydCBUZXh0IGZyb20gJy4uL1RleHQvVGV4dCdcblxuaW1wb3J0IHsgZWxvIGFzIHRoZW1lIH0gZnJvbSAnLi4vLi4vdGhlbWVzJ1xuaW1wb3J0IHsgdmFyaWFudHNQcm9wVHlwZSB9IGZyb20gJy4uLy4uL3V0aWwnXG5cbmNvbnN0IEFjdGlvbiA9ICh7XG4gIGFjdGlvbixcbiAgYWN0aW9uTGluayxcbiAgYWN0aW9uVGFyZ2V0LFxuICBvbkNsaWNrLFxuICBvbktleVVwLFxuICB2YXJpYW50LFxufSkgPT4gKFxuICA8QWN0aW9uQ29udGVudFxuICAgIG9uQ2xpY2s9e29uQ2xpY2t9XG4gICAgb25LZXlVcD17b25LZXlVcH1cbiAgICByb2xlPSdidXR0b24nXG4gICAgdGFiSW5kZXg9ey0xfVxuICA+XG4gICAgPFRleHRcbiAgICAgIGVsZW1lbnQ9J2EnXG4gICAgICBocmVmPXthY3Rpb25MaW5rPy5sZW5ndGggPiAwID8gYWN0aW9uTGluayA6IG51bGx9XG4gICAgICB0YXJnZXQ9e2FjdGlvblRhcmdldD8ubGVuZ3RoID4gMCA/IGFjdGlvblRhcmdldCA6IG51bGx9XG4gICAgICBzZW1pYm9sZFxuICAgICAgc2l6ZT0ndDMnXG4gICAgICB2YXJpYW50PXt2YXJpYW50fVxuICAgID5cbiAgICAgIHthY3Rpb259XG4gICAgPC9UZXh0PlxuICA8L0FjdGlvbkNvbnRlbnQ+XG4pXG5cbmNvbnN0IEFjdGlvbkNvbnRlbnQgPSBzdHlsZWQuc3BhbmBcbiAgY3Vyc29yOiBwb2ludGVyO1xuICBtYXJnaW4tbGVmdDogJHt0aGVtZS5zcGFjaW5ncy54eHhTbWFsbH07XG5cbiAgJjpmb2N1cyB7XG4gICAgb3V0bGluZTogbm9uZTtcbiAgfVxuYFxuXG5BY3Rpb24ucHJvcFR5cGVzID0ge1xuICBhY3Rpb246IFByb3BUeXBlcy5zdHJpbmcsXG4gIGFjdGlvbkxpbms6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGFjdGlvblRhcmdldDogUHJvcFR5cGVzLnN0cmluZyxcbiAgb25DbGljazogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgb25LZXlVcDogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgdmFyaWFudDogdmFyaWFudHNQcm9wVHlwZSxcbn1cblxuZXhwb3J0IGRlZmF1bHQgQWN0aW9uXG4iXX0= */"));
Action.propTypes = {
  action: PropTypes.string,
  actionLink: PropTypes.string,
  actionTarget: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onKeyUp: PropTypes.func.isRequired,
  variant: variantsPropType
};
export default Action;